import React from 'react';
import { COLORS, FONTS, FONT_SIZES } from '@bcm/constants';
import { View, Text, StyleSheet, Image } from 'react-native';
import { useSelector } from 'react-redux';

const ceoImageSize = 320;
const teamImageSize = 160;

const Team = () => {

	const isLandscape = useSelector( state => state.globals.isLandscape);

	const styles = StyleSheet.create({
		container: {
			height: isLandscape ? '80vh' : undefined,
			minHeight: isLandscape ? 600 : undefined,
			width: '100%',
			padding: isLandscape ? '15vw' : 10,
			flexDirection: isLandscape ? 'row' : 'column',
			justifyContent: 'center',
			alignItems: 'center',
			backgroundColor: COLORS.white,
		},
		columnContainer: {
			marginHorizontal: 15,
			flexDirection: 'column',
			justifyContent: 'center',
			alignItems: 'center',
		},
		rowContainerStart: {
			marginVertical: 10,
			flexDirection: isLandscape ? 'row' : 'column',
			width: '100%',
			justifyContent: isLandscape ? 'flex-start' : 'center',
			alignItems: isLandscape ? undefined : 'center',
		},
		rowContainerEnd: {
			marginVertical: 10,
			flexDirection: isLandscape ? 'row' : 'column',
			width: '100%',
			justifyContent: isLandscape ? 'flex-end' : 'center',
			alignItems: isLandscape ? undefined : 'center',
		},
		teamImageContainer: {
			marginHorizontal: 10,
			height: teamImageSize,
			width: teamImageSize,
			borderRadius: teamImageSize / 2,
		},
		textContainer: {
			justifyContent: 'center',
			alignItems: 'center',
			textAlign: 'center',
		},
		teamHeaderText: {
			fontFamily: FONTS.bold,
			fontSize: 30,
			color: COLORS.primary,
			borderBottomWidth: 2,
		},
		teamText: {
			maxWidth: isLandscape ? '25vw' : undefined,
			fontFamily: FONTS.default,
			fontSize: FONT_SIZES.lg,
			color: COLORS.dark,
			textAlign: 'center',
		},
		ceoImage: {
			height: ceoImageSize,
			width: ceoImageSize,
			borderRadius: ceoImageSize / 2,
		},
		ceoHeaderText: {
			fontFamily: FONTS.bold,
			fontSize: 30,
			color: COLORS.primary,
			borderBottomWidth: 2,
		},
		ceoText: {
			maxWidth: isLandscape ? '25vw' : undefined,
			fontFamily: FONTS.default,
			fontSize: FONT_SIZES.xxl,
			color: COLORS.dark,
		},
	});

	return (
		<View style={styles.container}>

			{/* CEO */}
			<View style={styles.columnContainer}>
				<Image
					source={require('../../assets/images/profile/orionWilmerding.png')}
					style={styles.ceoImage}
					resizeMode={'contain'}
				/>
				<View style={styles.textContainer}>
					<Text style={styles.ceoHeaderText}>T. Orion Wilmerding</Text>
					<Text style={styles.ceoText}>
                    CEO & Founder of BurnCam
					</Text>
				</View>
			</View>

			<View style={styles.columnContainer}>

				{/* Roy */}
				<View style={styles.rowContainerStart}>
					<Image
						source={require('../../assets/images/profile/royMiller.png')}
						style={styles.teamImageContainer}
						resizeMode={'contain'}
					/>
					<View style={styles.textContainer}>
						<Text style={styles.teamHeaderText}>Roy Miller, Ph.D.</Text>
						<Text style={styles.teamText}>Vice President of Business Development at 3Derm Systems</Text>
					</View>
				</View>

				{/* Barb Finer */}
				<View style={styles.rowContainerEnd}>
					{isLandscape && <View style={styles.textContainer}>
						<Text style={styles.teamHeaderText}>Barb Finer, MSA</Text>
						<Text style={styles.teamText}>Entrepreneur, Investor, Marketer, Connector, New Venture Advisor</Text>
					</View>}
					<Image
						source={require('../../assets/images/profile/barbFiner.png')}
						style={styles.teamImageContainer}
						resizeMode={'contain'}
					/>
					{!isLandscape && <View style={styles.textContainer}>
						<Text style={styles.teamHeaderText}>Barb Finer, MSA</Text>
						<Text style={styles.teamText}>Entrepreneur, Investor, Marketer, Connector, New Venture Advisor</Text>
					</View>}
				</View>

				{/* Phillipe Sommer */}
				<View style={styles.rowContainerStart}>
					<Image
						source={require('../../assets/images/profile/phillipeSommer.jpg')}
						style={styles.teamImageContainer}
						resizeMode={'contain'}
					/>
					<View style={styles.textContainer}>
						<Text style={styles.teamHeaderText}>Philippe Sommer, MBA</Text>
						<Text style={styles.teamText}>VC, Angel, Founder, Faculty and Academic Center Director at NEU</Text>
					</View>
				</View>
			</View>

		</View>
	);
};

export default Team;